export const VIDEOS_FEATURE_KEY = 'videos';
